import filters from '../../02-components/facet-filter/facet-filter.es6';
import search from '../../02-components/form/search/search.es6';
import tagGroup from '../../02-components/tags/tag-group/tag-group-facets.es6';
import results from '../../02-components/apps/app-grid/app-grid.es6';
import pagination from '../../02-components/pagination/pagination.es6';

let introSection;
let resultsSection;

function distributeData( data ) {
	filters.renderFacets( data );
	tagGroup.renderTags( data );
	results.renderAppGrid( data );
	pagination.renderPagination( data );
	search.renderSearch( data );
}

function updateUrl( requestUrl ) {
	let paramObj = {};

	// Pull only the parameters on the URL now that are not filters
	const queryString = window.location.search;
	if( queryString && queryString.length ) {
		queryString.substring( 1 ).split( '&' ).forEach( ( param ) => {
			const split = param.split( '=' );
			if( split[0].indexOf( 'filter' ) < 0 ) { // parameter is not a filter
				paramObj = {...paramObj, [split[0]]: split[1] };
			}
		} );
	}

	// Pull only the parameters in the new request that are filters
	// https://stackoverflow.com/a/42194793/738394
	requestUrl.split( '?' )[1].split( '&' ).reduce( (accum, val) => {
		if( val.indexOf( 'filter' ) === 0 ) {
			accum.push( val );
		}
		return accum;
	}, [] ).forEach( ( param ) => {
		const split = param.split( '=' );
		// combine with the paramObj and override if the key matches
		paramObj = {...paramObj, [split[0]]: split[1] };
	} );

	// Recombine the object into a param string
	const newQueryParams = Object.entries( paramObj ).map( ([ key, value]) => (
		`${key}=${value}`
	) ).join( '&' );

	window.history.replaceState( null, '', `${window.location.href.split( '?' )[0]}?${newQueryParams}` );
}

function requestData( url ) {
	const sectionClass = 'page-appstore__section--active';

	filters.facetsBusy( true );
	tagGroup.tagsBusy( true );
	results.appGridBusy( true );
	pagination.paginationBusy( true );

	if( !resultsSection.classList.contains( sectionClass ) ) {
		// Flip the page over into showing the results, not the intro
		introSection.classList.remove( sectionClass );
		resultsSection.classList.add( sectionClass );
	}

	fetch( url )
		.then( response => {
			if( !response.ok ) {
				throw new Error( response.statusText );
			}
			return response.json();
		} )
		.then( data => {
			distributeData( data );
			updateUrl( url );
		} )
		.catch( error => {
			console.error( 'Unable to fetch results', error );
			distributeData( null );
		} );
}

function init() {
	introSection = document.querySelector( '.page-appstore__intro' );
	resultsSection = document.querySelector( '.page-appstore__results' );
	if( !introSection || !resultsSection ) { return; }

	filters.setupTemplateRequest( requestData );
	results.setupTemplateRequest( requestData );
	pagination.setupTemplateRequest( requestData );
	search.setupTemplateRequest( requestData );
}

if (
	document.readyState === "complete" ||
	(document.readyState !== "loading" && !document.documentElement.doScroll)
) {
	init();
} else {
	let eventSrcUrl = null;
	document.addEventListener('DOMContentLoaded', ( e ) => {
		if( eventSrcUrl !== e.target.URL ) {
			eventSrcUrl = e.target.URL
			init();
		}
	} );
}